import React, { Fragment, useState, useEffect } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { FaUser } from 'react-icons/fa';

import { Navigation } from 'components';
import navigationConfig from './navigationConfig';

import getInitials from 'utils/getInitials';
import ApiMServer from 'services/ApiMServer';

const NavBar = (props) => {
  const { openMobile, onMobileClose } = props;

  const [name, setName] = useState();
  const [companyName, setCompanyName] = useState();
  const [menuUserKey, setMenuUserKey] = useState(0);

  useEffect(() => {
    const syncUser = async () => {
      const raw = localStorage.getItem('userData');
      if (!raw) return;

      let userData = JSON.parse(raw);
      setName(userData?.name || userData?.email);
      setCompanyName(userData.companyName);

      try {
        const { data: fresh } = await ApiMServer.get(`/users/${userData._id}`);
        if (fresh) {
          userData = { ...userData, ...fresh, theme: userData.theme || 'dark' };
          localStorage.setItem('userData', JSON.stringify(userData));
          setName(userData?.name || userData?.email);
          setCompanyName(userData.companyName);
          setMenuUserKey((k) => k + 1);
        }
      } catch (error) {
        console.error('Erro ao sincronizar usuário no menu:', error);
      }
    };

    syncUser();
  }, []);

  const navbarContent = (
    <div className="p-2">
      {/* Perfil do usuário */}
      <div className="d-flex flex-column align-items-center mb-3">
        <div
          className="rounded-circle d-flex align-items-center justify-content-center mb-2"
          style={{
            width: 60,
            height: 60,
            backgroundColor: 'var(--brand-dark-green)',
            boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
            border: '3px solid var(--brand-light-green)',
            color: 'white'
          }}
        >
          {name ? getInitials(name) : <FaUser size={24} />}
        </div>

        <h6 className="fw-bold mb-0" style={{ color: 'var(--navbar-text)' }}>{name}</h6>
        <div className="text-muted small mb-2">{companyName}</div>
      </div>

      <div style={{ height: '1px', backgroundColor: 'var(--card-border)', margin: '0.5rem 0 1rem' }} />

      {/* Menu de navegação */}
      <div className="overflow-auto pb-5" style={{ maxHeight: 'calc(100vh - 200px)' }}>
        {navigationConfig && navigationConfig.map((list) => (
          <Navigation
            component="div"
            key={`${list.title ? list.title : 'menu'}-${menuUserKey}`}
            pages={list.pages}
            title={list.title}
          />
        ))}
      </div>
    </div>
  );

  return (
    <Fragment>
      <Offcanvas
        show={openMobile}
        onHide={onMobileClose}
        className="d-lg-none"
        placement="start"
        style={{ backgroundColor: 'var(--navbar-bg)', width: '230px', minWidth: '230px' }}
      >
        <Offcanvas.Body className="p-0 overflow-hidden">
          {navbarContent}
        </Offcanvas.Body>
      </Offcanvas>

      <div
        className="h-100 d-none d-lg-block overflow-hidden navbar-desktop"
      >
        {navbarContent}
      </div>
    </Fragment>
  );
};

export default NavBar;
